// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ZqwP","header":"ReportDetails_header__2Wpo2","title":"ReportDetails_title__8Oy1s","left":"ReportDetails_left__1P86f"};